<template>
  <Layout>
    
    
    <div class="grid grid-cols-2" >
      
      <div v-if="!sermonLink && !mobileOpen1"><BaseInput class="mt-2 pl-2 px-2" style="color: #C38437" label="Search Sermons" v-model="name" /></div>
      <div class="pt-10">
        <button v-if="!mobileOpen1"
            type="button"
            v-on:click="toggleMobilemenu1(); clear();"
            class="relative inline-flex items-center pl-4 px-5 py-4 pt-3 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
            >
            <img class="h-6 w-6" src="../assets/biblecalendar.png" alt />
            <a  class="absolute inset-0 z-6 px-2 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
            <h1 class=tracking-wider >Search Dates</h1>
            </a>
       </button>
        <button v-if="!mobileOpen1"
            type="button"
            v-on:click=" getSermons(); "
            class="relative inline-flex items-center pl-4 px-5 py-4 pt-0 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
            >
            <img class="h-6 w-6" src="../assets/refresh2.png" alt />
            <a  class="absolute inset-0 z-6 px-2 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
            <h1 class=tracking-wider >Refresh</h1>
            </a>
       </button></div>
       
         
    </div>
     <div v-if="mobileOpen1">
        <h1 class="block uppercase tracking-wide text-gray-700 text-lg font-thin mb-2 pt-6">START & END DATE</h1>
        <BaseInput label="" type="date" class=" bg-gray-200 rounded pl-2 px-2" placeholder="..." v-model="searchDate" />
          <BaseInput label="" type="date" style="background-color: #C38437" class=" rounded  pl-2 px-2" placeholder="..." v-model="endDate" />
          <div class="pt-2">
          <button
            type="button"
            v-on:click="getSermonDate(searchDate, endDate); toggleMobilemenu1();"
            class="inline-flex items-center px-2 py-0  hover:bg-yellow-500 border border-transparent text-sm leading-5 font-medium rounded-md text-white focus:outline-none focus:shadow-outline-indigo focus:border-yellow-500 active:bg-yellow-500 transition duration-150 ease-in-out"
              >
              
          <img class="h-12 w-auto" src="../assets/searchBible.png" alt="Workflow" />
        </button>
      </div>
      </div>
    <div v-if="!sermons.length" class="flex flex-col-2 pl-2">
          <img
            class="rounded-lg h-full"
            src="../assets/nosermons.png"
            alt=""
            />
          
          </div>
     
    <iframe v-if="sermonLink" class="block md:hidden h-60 w-full px-2 rounded-lg"  frameborder='0' modestbranding=1  controls=0 rel=0 :src=sermonLink.document></iframe> 
    <div v-if="!sermonLink" class=" mx-auto p-2 md:max-w-7xl lg:max-w-7xl">
        <div v-for="ser2 in sermons" :key="ser2.id" class="">
    <figure  class="">
      <div class="items-left justify-left pt-1 border-b" >
       
        <div class="font-medium">
          <a class="" style="color: #C38437">Listen to Sermon : </a>
               <button 
                      type="button"
                      v-on:click="getCheckDoc(ser2.sermonID); " :id="ser2.sermonID"
                      class=""
                         >
                    <img class="h-8 w-8 pt-1" src="../assets/audio3.png" alt="Workflow" />
                  </button>
            <!-- <button v-if="!mobileOpen"
              type="button"
              v-on:click="toggleMobilemenu();"
              class="inline-flex items-center px-2 py-2 border border-transparent text-sm leading-5  font-medium rounded-md text-white focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700  transition duration-150 ease-in-out"
                > Listen to Sermon : 
            <img class="h-8 w-auto " src="../assets/closedbible.png" alt="Workflow" />
              </button>-->
                <!--<button v-if="mobileOpen"
              type="button"
              v-on:click="toggleMobilemenu();"
              class="inline-flex items-center px-2 py-2 border border-transparent text-sm leading-5  font-medium rounded-md text-white focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700  transition duration-150 ease-in-out"
                > Listen to Sermon : 
            <img class="h-8 w-auto " src="../assets/openbible.png" alt="Workflow" />
              </button>--> 
       
        </div>
        <figcaption class="pl-0 items-left justify-left ">
            <!--<img class="rounded-full w-9 h-9" src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/avatars/karen-nelson.png" alt="profile picture">-->
            <div class="space-y-0.1 font-medium  text-left  ms-1 flex-1">
                <div><a style="color: #C38437">Preacher : </a>{{ser2.Pastor}}   </div>
                
                <!--<div class="text-sm text-gray-500 dark:text-gray-400 ">Added On : {{  
                    new Date(hardware.timestamp).toLocaleDateString()
                    }}</div>-->
            </div>
              <div class="space-y-0.1 font-medium  text-left  ms-1 flex-1">
                <div><a style="color: #C38437">Sermon Name :</a> {{ser2.sermonName.slice(0,40)}} </div>
                
                <!--<div class="text-sm text-gray-500 dark:text-gray-400 ">Added On : {{  
                    new Date(hardware.timestamp).toLocaleDateString()
                    }}</div>-->
            </div>
               <div class="space-y-0.1 font-medium  text-left  ms-1 flex-1">
                <div><a style="color: #C38437">Sermon Text :</a> {{ser2.text.slice(0,25)}} </div>
                
                <!--<div class="text-sm text-gray-500 dark:text-gray-400 ">Added On : {{  
                    new Date(hardware.timestamp).toLocaleDateString()
                    }}</div>-->
            </div>
               <div class="space-y-0.1 font-medium  text-left  ms-1 flex-1">
                <div><a style="color: #C38437">Sermon Date :</a> {{new Date(ser2.entryDate).toLocaleDateString()}} {{ser2.entryTime}} </div>
                
                <!--<div class="text-sm text-gray-500 dark:text-gray-400 ">Added On : {{  
                    new Date(hardware.timestamp).toLocaleDateString()
                    }}</div>-->
            </div>
      
        </figcaption> </div>
    
    </figure>
    </div>
    </div>
     <iframe class="hidden md:block w-full h-60 px-2" frameborder='0' modestbranding=1  controls=0 rel=0 :src=sermonLink.document></iframe>  
   

     <!--  <div class="flex flex-col ">
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div
          class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
        >
          <table class=" min-w-full sm:min-h-full lg:min-w-full">
            <thead>
              <tr>
                <th
                  class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  Date Added
                </th>
             
           
                   <th
                  class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                 Text
                </th>
           
                <th
                  class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                Play
                </th>
          
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-for="ser in sermons" :key="ser.id">
                <td
                  class="px-0 py-4 whitespace-no-wrap border-b border-gray-200"
                >
                  <div class="flex items-center">
                   
                    <div class="ml-4">
                      <div class="text-sm leading-5 text-gray-900">
                         {{ new Date(ser.timestamp).toLocaleDateString() }} 
                           <div class="text-sm leading-5 text-red-800">
                        Pastor : {{ ser.Pastor }} 
                      
                      </div>
                        <div class="text-sm leading-5 text-gray-900">
                        Sermon :  {{ ser.sermonName }} 
                      </div>
                      </div>
                    
                      
                    </div>
                  </div>
                </td>
              
                <td
                  class="px-0 py-4 whitespace-no-wrap border-b border-gray-200"
                >
                  <div class="flex items-center">
                   
                    <div class="ml-2">
                      <div class="text-sm leading-5 text-yellow-500">
                     {{ ser.text}}
                      </div>
                
                    </div>
                  </div>
                </td>
                <td
                  class="px-0 py-2 whitespace-no-wrap border-b border-gray-200"
                >
                  <div class="text-base leading-5 text-blue-600 pl-2">
                  <a  target="_blank" :href="ser.document"><img v-if="ser.document" class="h-8 w-auto" src="../assets/play-button.png"></a> 
                  </div>
                </td> 
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
        <img
              class="h-28 w-full pt-2 "
              src="../assets/background.png"
              alt="Workflow logo"
            />-->
        
    
    

</Layout>
</template>



<script>
import Layout from "./layouts/Main";
import BaseInput from "../components/BaseInput";
//import TopLoaderPages from "../components/TopLoaderPages";
//import HomeSearchEmployees from "../components/HomeSearchEmployees";
//import HomeNotLive from "../components/HomeNotLive";
//import Auth from "../components/Auth";
import { mapGetters } from "vuex";


export default {
  name: 'Home',
  components: { Layout, BaseInput},
  data() {
    return {
      sermons: {},
      name : "",
      pages1 : "",
      mobileOpen : false,
      mobileOpen1 : false,
      searchDate: "",
      sermonLink : "",
      endDate: "",
      tab : "",
    };
  },
  created() {
    this.userData = this.currentUserData;
    this.type = this.currentUserData.userType;
    this.userStatus = this.currentUserData.status;
    this.getSermons();
    //this.getPages1();
   //if(this.type === "employer")
   //{
     //this.$router.push({
      //  name: "contact",
     // });
   //}

  },
    watch: {
    name(name) {
      this.getSermonName(name.toLowerCase());
    },
   
  },
  computed: {
    ...mapGetters(["isLoggedIn", "currentUserData"]),
  },
   methods: {
      getPages1() {
      //const employer = [];
      const employerData = this.$db
        .collection("websitestatus")
        .where("status", "==", "active");

      employerData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.pages1 = data;
        });
      });
    },
     setTab(tab) {
      this.tab = tab;
    },
    getSermons() {
      const users = [];
      const pendingApprovalsRef = this.$db
        .collection("sermons")
        .where("sermonID", ">=", 1)
        .orderBy("sermonID" , "desc")
        .limit(8)
       
      pendingApprovalsRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          users.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        this.sermons = users;
      });
      this.sermonLink = ""
      //this.name = ""
    },
      async getCheckDoc(id) {
      //const employer = [];
      const certData = this.$db
        .collection("sermonLinks")
        .where("sermonID", "==", id)
        
        
      certData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.sermonLink = data;
        });
        //this.removeTicket();
        //this.deleteAttachPlanning();
      });
    },
      getSermonName(name) {
      const users = [];
      const pendingApprovalsRef = this.$db
        .collection("sermons")
        .where("search", "array-contains", name)
       
      pendingApprovalsRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          users.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        this.sermons = users;
      });
    },

    toggleMobilemenu() {
      this.mobileOpen = !this.mobileOpen;
    }, 
      toggleMobilemenu1() {
      this.mobileOpen1 = !this.mobileOpen1;
    },
     getSermonDate(searchDate, endDate) {
    const hardwares = [];
    this.$db
      .collection("sermons")
      .where("searchDate", ">=", searchDate)
      .where("searchDate", "<=", endDate)
      .orderBy('searchDate')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      })
      ;
      this.sermons = hardwares;
      this.sermonLink = ""
      //this.sumTravis();
    },   
    clear(){
      this.searchDate = "",
      this.endDate = "",
      this.sermonLink = "",
      this.name = ""
    },

    getPages() {
      //const employer = [];
      const employerData = this.$db
        .collection("websitepages")
        .where("status", "==", "active");

      employerData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.pages = data;
        });
      });
    },
   }
  //<div v-if="currentUserData.status !== 'approved'">
    //  <TopLoader />
      
    //</div>
};
</script>

<style>
.container {
  position: relative;
  overflow: hidden;
  height: 100%;
  padding-top: 56%; 
  
  /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 80%;
  max-height: 289px;
  max-width: 514px;

}
</style>
